import Keyword from './Keyword';

export default class StringKeyword extends Keyword {}